import React from 'react';
import { Link } from 'react-router-dom';
import './CarrierCard.css';

import { IMAGES } from '../Assets/Images/index';

const PrefixCodesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    {/* Document with lines */}
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="8" y1="12" x2="16" y2="12"/>
    <line x1="8" y1="16" x2="16" y2="16"/>
    <line x1="8" y1="20" x2="12" y2="20"/>
    {/* Magnifying glass overlay */}
    <circle cx="17" cy="17" r="3" fill="none" stroke="currentColor" strokeWidth="1.5"/>
    <line x1="19.5" y1="19.5" x2="22" y2="22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

function CarrierCard({ carrier }) {
  const logo = carrier.logoKey ? IMAGES[carrier.logoKey] : null;

  return (
    <div className="carrier-card">
      <div className="carrier-card-content">
        <div className="carrier-logo-section">
          {logo ? (
            <img
              src={logo}
              alt={`${carrier.name} logo`}
              className="carrier-logo"
            />
          ) : (
            <div className="carrier-logo-placeholder">
              {carrier.name.charAt(0)}
            </div>
          )}
        </div>

        <div className="carrier-info-section">
          <h3 className="carrier-name">{carrier.name}</h3>
          <p className="carrier-description">{carrier.description}</p>

          <div className="prefix-codes-section">
            <div className="prefix-codes-header">
              <span className="prefix-codes-icon">
                <PrefixCodesIcon />
              </span>
              <h4 className="prefix-codes-title">Supported {carrier.name} Prefix Codes</h4>
            </div>
            <p className="prefix-codes-list">
              {carrier.prefixCodes.map((code, index) => {
                const shouldHighlight = index % 7 === 0;
                return (
                  <span key={index}>
                    <span className={shouldHighlight ? 'prefix-code-highlight' : ''}>
                      {code}
                    </span>
                    {index < carrier.prefixCodes.length - 1 && ', '}
                  </span>
                );
              })}
            </p>
          </div>

          {carrier.slug && (
            <Link to={`/carriers/${carrier.slug}`} className="carrier-learn-more">
              Learn More →
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default CarrierCard;